module.exports = __webpack_public_path__ + "img/car-style_top.f730afe6.svg";